const parseParams = (params) => {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && Array.isArray(params[key]);

    if (!isParamTypeObject) {
      options += `${encodeURIComponent(key)}=${encodeURIComponent(
        params[key]
      )}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${encodeURIComponent(key)}=${encodeURIComponent(element)}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
};

const apiFetch = async ({ url, params = {}, method = "GET", restApi }) => {
  try {
    let fullUrl = url;

    // Aggiungi i parametri alla query string se metodo GET
    if (
      method.toUpperCase() === "GET" &&
      params &&
      Object.keys(params).length
    ) {
      const queryString = parseParams(params);
      fullUrl += `?${queryString}`;
    }

    const headers = restApi ? { Accept: "application/json" } : {};

    const options = {
      method,
      headers,
    };

    // Per POST/PUT/DELETE possiamo inviare params nel body
    if (method.toUpperCase() !== "GET") {
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(params);
    }

    const response = await fetch(fullUrl, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Proviamo a parse JSON, ma se fallisce ritorniamo il testo
    let data;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default apiFetch;
